import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Routes, RouterModule } from "@angular/router";
import { EditLessonComponent } from "./editLesson.component";
import { IonicModule } from "@ionic/angular";
import { SharedheaderModule } from "src/app/header/sharedheader/sharedheader.module";

const routes: Routes = [
  {
    path: "",
    component: EditLessonComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedheaderModule,
    RouterModule.forChild(routes),
  ],
  providers: [EditLessonComponent],
  declarations: [EditLessonComponent],
})
export class EditLessonComponentModule {}
